
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class LogoContent extends Vue {
  @Prop() private msg!: string;
}
